/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const SESSION_KEYS = {
  IS_AUTHENTICATED: 'auth_session_active',
  AUTH_TOKEN: 'auth_session_token',
  USER_DATA: 'auth_user_data',
  LAST_ACTIVITY: 'auth_last_activity',
  SESSION_START: 'auth_session_start'
};
